var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBase',{style:(_vm.zumiStyle()),attrs:{"iconName":"済","width":_vm.width,"height":_vm.width},scopedSlots:_vm._u([{key:"default",fn:function({ viewbox }){return [_c('IconZumi',{on:{"viewbox":viewbox}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }